import { Dispatch } from 'redux'

import { getRecipeAvailabilityByDeliveryDate } from '@library/api-recipeavailability'
import { RecipeAvailability } from '@library/api-recipeavailability/src/types'

import { RecipeAvailabilityStore } from 'reducers/recipeAvailability'

import { actionTypes } from './actionTypes'

type ImmutableState<T> = {
  get<K extends keyof T>(name: K): T[K]
}
type BasketSlice = ImmutableState<{ date: string }>
type GetState = () => Record<string, unknown> & { basket: BasketSlice }

function changeRecipeAvailability(recipeAvailability: RecipeAvailabilityStore) {
  return {
    type: actionTypes.RECIPE_AVAILABILITY_UPDATED,
    recipeAvailability,
  }
}

export function loadRecipeAvailability() {
  return async (dispatch: Dispatch<any>, getState: GetState) => {
    const { basket } = getState()
    const date = basket.get('date')

    const recipeAvailabilityData = await getRecipeAvailabilityByDeliveryDate(date)

    const recipeAvailabilityMapped = recipeAvailabilityData.reduce(
      (accumulator: RecipeAvailabilityStore, recipe: RecipeAvailability) => ({
        [recipe.recipeId]: recipe,
        ...accumulator,
      }),
      {},
    )

    dispatch(changeRecipeAvailability(recipeAvailabilityMapped))
  }
}
